import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  $(document).ready(function(){
  $('.support').addClass('active');
  $('.support a').css('color','#fff');
   $('.support img').attr('src','./assets/image/icon/Support.png');
  });
  $(".header-title p").text('Support Center');
  }

}
